<mat-card class="cardWithShadow theme-card">
  <mat-card-content>
    <div class="network-wrapper">
      
      <!-- Header / Buscador -->
      <div class="network-header">
        <mat-form-field appearance="outline" class="network-search">
          <mat-label>Buscar Contacto</mat-label>
          <input
            matInput
            [(ngModel)]="palabraClave"
            (keyup)="callData()"
            placeholder="Escribe aquí..."
          />
        </mat-form-field>
      </div>

      <!-- Grid de contactos -->
      <div class="network-grid">
        <div
          class="network-card"
          *ngFor="let contacto of mired"
        >
          <img
            [src]="contacto.imgProfileResize"
            class="network-avatar"
            alt="Foto"
          />

          <div class="network-body">
            <h6 class="network-name">{{ contacto.nombre }}</h6>
            <p class="network-role texto-pre" [innerHTML]="contacto?.cargo"></p>
          </div>

          <div class="network-footer">
            <a
              [href]="contacto.linkProfile"
              target="_blank"
              class="btn btn-sm network-btn"
            >
              Ver Tarjeta
            </a>
          </div>
        </div>
      </div>

      <!-- Paginador -->
      <div class="network-paginator">
        <mat-paginator
          [length]="length"
          [pageSize]="12"
          [pageSizeOptions]="[12, 24, 50]"
          (page)="getServerData($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </mat-card-content>
</mat-card>
